import React from 'react';
import { ArrowRight } from 'lucide-react';
interface CTAButtonProps {
  children: React.ReactNode;
  variant?: 'primary' | 'secondary';
  fullWidth?: boolean;
  className?: string;
  onClick?: () => void;
  href?: string;
}
export function CTAButton({
  children,
  variant = 'primary',
  fullWidth = false,
  className = '',
  onClick,
  href
}: CTAButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center font-bold text-lg py-4 px-8 rounded-full transition-all duration-300 transform hover:-translate-y-1 hover:shadow-lg active:translate-y-0 focus:outline-none focus:ring-4 focus:ring-opacity-50';
  const variants = {
    primary: 'bg-[#e63946] text-white hover:bg-[#d62839] shadow-md focus:ring-[#e63946]',
    secondary: 'bg-[#1e3a5f] text-white hover:bg-[#162a45] shadow-md focus:ring-[#1e3a5f]'
  };
  const handleClick = () => {
    if (onClick) {
      onClick();
    }
    if (href) {
      window.open(href, '_blank');
    }
  };
  return <button className={`${baseStyles} ${variants[variant]} ${fullWidth ? 'w-full' : ''} ${className}`} onClick={handleClick} data-id="element-19">
      {children}
      <ArrowRight className="ml-2 h-5 w-5" data-id="element-20" />
    </button>;
}